import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { Loader } from 'common/react/components/Loader';

import { RoundButton } from './RoundButton';
import { changeRound } from 'common/store/modules/competition-nav/thunks/change-round';

export const RoundListNavItem = ({ onRoundClick }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const roundsListRef = useRef();

    const roundElements = useRef({});
    const urlSearchParams = new URLSearchParams(globalThis.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const roundId = params.Round;

    const roundsList = nav?.rounds;
    const season = nav?.season;

    useEffect(() => {
        if (!roundsList) {
            return;
        }

        const targetElement = Object.values(roundElements.current).find(
            (el) => {
                if (!el) {
                    return false;
                }

                const isMatchingId = el.dataset.roundId === roundId;
                const statusElement = el.querySelector(
                    '.competition-nav__round-list-item'
                );
                const isActive =
                    statusElement?.classList.contains('is-active') &&
                    statusElement?.classList.contains(
                        'competition-nav__round-list-item--current-round'
                    );

                return isMatchingId || (!roundId && isActive);
            }
        );

        if (targetElement) {
            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'nearest'
            });
        }
    }, [roundsList, roundId]);

    if (!roundsList) {
        return (
            <ul className="competition-nav__round-list">
                <Loader />
            </ul>
        );
    }

    const onNavItemClick = (event, label, disableRounds) => {
        if (
            disableRounds &&
            label?.roundNumber &&
            typeof onRoundClick === 'function'
        ) {
            onRoundClick(label.roundNumber);
        }

        roundsListRef?.current.dispatchEvent(
            new Event(PULSE.app.common.CONSTANTS.EVENTS.INTERACTION.CHANGE, {
                bubbles: true
            })
        );

        dispatch(
            changeRound({
                round: label
            })
        );
    };

    return (
        <ul className="competition-nav__round-list" ref={roundsListRef}>
            {roundsList.length
                ? roundsList.map((round) => (
                      <li
                          className="competition-nav__round-list-item-wrapper"
                          key={round.name}
                          ref={(element) =>
                              (roundElements.current[round.id] = element)
                          }
                          data-round-id={round.id}
                      >
                          <RoundButton
                              round={round}
                              currentRoundNumber={
                                  season?.currentRoundNumber ?? -1
                              }
                              onClick={onNavItemClick}
                          />
                      </li>
                  ))
                : ''}
        </ul>
    );
};

RoundListNavItem.propTypes = {
    onRoundClick: PropTypes.func
};
